module.exports = __webpack_public_path__ + "img/Solicitud.c239da5c.svg";